export default __webpack_public_path__ + "img/pin_icons/projector_w.png";